import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loading } from '@cubeyou-team/hx-react-components';
import { API, MFE_URLS } from 'src/constants/config';
import MicroFrontend from 'src/MicroFrontend';
import { ApiRequestHeader } from 'src/utils';
import { setTokens } from 'src/utils/AuthHelperMethods';

const mapApp = {
  affinity: {
    host: MFE_URLS.AFFINITY,
    name: 'AffinityMFE',
    getQuery: (s: any) => s.analyse.query,
    getInstanceId: (s: any) => s.analyse.tabInstanceId,
  },
  segmentation: {
    host: MFE_URLS.SEGMENTATION,
    name: 'SegmentationMFE',
    getQuery: (s: any) => s.segmentation.query,
    getInstanceId: (s: any) => s.segmentation.tabInstanceId,
  },
  compare: {
    host: MFE_URLS.COMPARE,
    name: 'CompareMFE',
    getQuery: (s: any) => s.compare.queries,
    getInstanceId: (s: any) => s.compare.tabInstanceId,
  },
};

const Export = () => {
  const params = useParams();
  const [state, setState] = useState(null);
  useEffect(() => {
    fetch(`${API.EXPORT.BASE_URL}/export/json/${params.id}`, {
      headers: ApiRequestHeader(),
    })
      .then(r => r.json())
      .then(state => {
        setState(state);
        setTokens(state.tokens.accessToken, state.tokens.idToken);
      });
  }, [params.id]);
  if (!state) return <Loading isLoading={!state} />;

  return (
    // @ts-ignore
    <MicroFrontend
      host={mapApp[state.type].host}
      name={mapApp[state.type].name}
      query={mapApp[state.type].getQuery(state.data)}
      instanceId={mapApp[state.type].getInstanceId(state.data)}
      state={state.data}
      external
      onError={console.error}
      repositoryCollapsed
    />
  );
};

export default Export;
